import './dialogLayout.scss';

import React from 'react';

import { usePlatformContext } from '../../../../Context/PlatformContext/PlatformContext';
import { ButtonClassType } from '../../Button/Button';
import { withClassSM } from '../../ViewFactory';
import { BaseDialog } from '../BaseDialog/BaseDialog';
import { getDialogButton } from './DialogLayoutUtils';

export enum DialogLayoutStyle {
    Default = 'default',
    Danger = 'danger',
}

export interface DialogLayoutProps {
    title: string;
    open: boolean;
    onClose(): void;
    renderContent?(): void;
    style?: DialogLayoutStyle;
    layoutClasses?: object;
    //* actions
    leftAction(): void;
    leftActionLabel: string;
    leftActionDisabled?: boolean;
    rightAction(): void;
    rightActionLabel: string;
    rightActionDisabled?: boolean;
    renderCustomActions?(): void;
    children?: React.ReactNode;
}

const DialogLayout: React.FunctionComponent<DialogLayoutProps> = ({
    open,
    renderContent,
    style,
    //layoutClasses: { actions },
    //* buttons
    leftActionLabel,
    leftAction,
    leftActionDisabled,
    rightActionLabel,
    rightAction,
    rightActionDisabled,
    onClose,
    layoutClasses,
    //* custom buttons
    renderCustomActions,
    children,
    ...rest
}: DialogLayoutProps) => {
    const { isMobile: xs } = usePlatformContext();
    return (
        <BaseDialog scroll="body" open={open} onClose={onClose} {...rest}>
            <div className="dialog-layout-content">
                {children}
                {renderContent && renderContent()}
                {!renderCustomActions && (
                    <div {...withClassSM('dialog-layout-content-actions', xs)}>
                        {getDialogButton({
                            title: leftActionLabel,
                            onClick: leftAction,
                            variant:
                                style === DialogLayoutStyle.Danger
                                    ? ButtonClassType.Danger
                                    : ButtonClassType.Standard,
                            disabled: leftActionDisabled,
                            isMobile: xs,
                        })}
                        {getDialogButton({
                            title: rightActionLabel,
                            onClick: rightAction,
                            disabled: rightActionDisabled,
                            variant: ButtonClassType.Outlined,
                            isMobile: xs,
                        })}
                    </div>
                )}
                {renderCustomActions && renderCustomActions()}
            </div>
        </BaseDialog>
    );
};

export { DialogLayout };
